import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-305f2261"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arcode-main-toolbar-panel-title" }, " Deploy contract ", -1))
const _hoisted_2 = {
  key: 0,
  class: "deploy-container"
}
const _hoisted_3 = { class: "form-input" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Network", -1))
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "form-input" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Wallet", -1))
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "form-input" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Method", -1))
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "contract-src-file" }, "Contract-Src from File", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "contract-src-tx" }, "Contract-Src from TX", -1))
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { class: "form-input" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Contract Source", -1))
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "form-input" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Contract Initial State", -1))
const _hoisted_22 = ["disabled"]
const _hoisted_23 = ["value"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "title-tags" }, "Tags", -1))
const _hoisted_25 = {
  key: 0,
  class: "no-results"
}
const _hoisted_26 = { class: "form-input col-key" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Name", -1))
const _hoisted_28 = ["disabled", "onUpdate:modelValue"]
const _hoisted_29 = { class: "form-input col-value" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Value", -1))
const _hoisted_31 = ["disabled", "onUpdate:modelValue"]
const _hoisted_32 = { class: "form-input col-action" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "title-tags" }, "Balance", -1))
const _hoisted_34 = { class: "deploy-menu" }
const _hoisted_35 = { class: "span-balance" }
const _hoisted_36 = { class: "text-right" }
const _hoisted_37 = { class: "" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = { class: "" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = { class: "text-center-f" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Add Tag", -1))
const _hoisted_44 = { class: "text-center-f" }
const _hoisted_45 = ["disabled"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Deploy Now", -1))
const _hoisted_47 = { class: "form-input" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Contract Source TX", -1))
const _hoisted_49 = ["disabled"]
const _hoisted_50 = { class: "form-input" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "New Contract Initial State", -1))
const _hoisted_52 = ["disabled"]
const _hoisted_53 = ["value"]
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "title-tags" }, "Tags", -1))
const _hoisted_55 = {
  key: 0,
  class: "no-results"
}
const _hoisted_56 = { class: "form-input col-key" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Name", -1))
const _hoisted_58 = ["disabled", "onUpdate:modelValue"]
const _hoisted_59 = { class: "form-input col-value" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Value", -1))
const _hoisted_61 = ["disabled", "onUpdate:modelValue"]
const _hoisted_62 = { class: "form-input col-action" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "title-tags" }, "Balance", -1))
const _hoisted_64 = { class: "deploy-menu" }
const _hoisted_65 = { class: "span-balance" }
const _hoisted_66 = { class: "text-right" }
const _hoisted_67 = { class: "" }
const _hoisted_68 = ["disabled"]
const _hoisted_69 = { class: "" }
const _hoisted_70 = ["disabled"]
const _hoisted_71 = { class: "text-center-f" }
const _hoisted_72 = ["disabled"]
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Add Tag", -1))
const _hoisted_74 = { class: "text-center-f" }
const _hoisted_75 = ["disabled"]
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Deploy Now", -1))
const _hoisted_77 = {
  key: 1,
  class: "deploy-container text-center-f"
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center no-results" }, "Please login first!", -1))
const _hoisted_79 = {
  key: 2,
  class: "deploy-container text-center-f"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Contract deployed successfully!", -1))
const _hoisted_81 = { class: "text-center" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Contract TX:", -1))
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_84 = { class: "text-center" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Contract Src TX:", -1))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_87 = ["href"]

import { ref, reactive, computed, watchEffect, onMounted } from 'vue'
import DefaultIcon from '@/components/atomic/DefaultIcon'
import { ArweaveWrapper, arweaveNetworks, defaultNetwork, onLocalnetByString } from '@/core/ArweaveWrapper'
import { WarpContracts} from '@/core/WarpContracts'
import { ContractData, ArWallet, 
  FromSrcTxContractData, Tags } from 'warp-contracts';
import { createToast } from 'mosha-vue-toastify'
import { DefaultWorkspace } from '@/components/composed/DefaultWorkspace'


export default /*#__PURE__*/_defineComponent({
  __name: 'DeployContract',
  props: {
  iframe: Boolean,
  workspace: Object,
  tokenState: Object,
  login: Object,
  networkParam: String
},
  setup(__props) {

const props = __props;

const networks = computed(() => {
  return arweaveNetworks
});
const selDeployFileContractLocation = ref('')
const txtDeployFileContractLocationByTx = ref('')
const selDeployFileStateLocation = ref('')
const selDeployFileStateLocation2 = ref('')
const txtUseArweaveGw = ref(false);
const txtDisableBundling = ref(false);
const txtUseArweaveGw2 = ref(false);
const txtDisableBundling2 = ref(false);
const deployedContractTX = ref('')
const loadingDeployContract = ref(false)
const selDeployMethod = ref('contract-src-file')
const defaultSelNetwork = props.networkParam ? props.networkParam : defaultNetwork
const selNetwork = ref(defaultSelNetwork)
const prevNetwork = ref(selNetwork.value)

const tagsList1 = reactive<Tags>([])
const tagsList2 = reactive<Tags>([])
const mainAddress = ref(props.login.mainAddress)
const balance = ref('0')
const isBridgeActive = ref(false)
const arcodePreviewUrl = (tx) => {
  return `https://arcode.studio/#/${tx}?network=${selNetwork.value}`
};

const deployContract = async (
  statePath: string,
  contractSrcPath: string,
  workspace: DefaultWorkspace,
  tags: Tags) => {
  let contractSrc = ``
  let initStateSrc = ``
  loadingDeployContract.value = true
  try {
    const useArweaveGw = txtUseArweaveGw.value
    const customGw = ''
    const arweaveWrapper = new ArweaveWrapper(selNetwork.value)
    const arweave = arweaveWrapper.arweave
    const warpContracts = new WarpContracts(arweave, customGw, useArweaveGw)

    // Iframe fix
    const loginMethod = props.login.method
    if (isBridgeActive.value && (loginMethod === 'arconnect' || loginMethod === 'finnie')) {
      props.login.hijackArweavePostAPI(arweave)
    }
    const stateName2 = statePath.split('/')[statePath.split('/').length - 1]
    let statePath2 = statePath.split('/').splice(0, statePath.split('/').length - 1).join('/')
    if (statePath2 === '') {
      statePath2 = '/'
    }
    const stateFileId = workspace.findFileIdByName(statePath2, stateName2)
    const iState = workspace.editors.findIndex(ed => ed.id == stateFileId)
  
    const contractName2 = contractSrcPath.split('/')[contractSrcPath.split('/').length - 1]
    let contractPath2 = contractSrcPath.split('/').splice(0, contractSrcPath.split('/').length - 1).join('/')
    if (contractPath2 === '') {
      contractPath2 = '/'
    }
    const contractFileId = workspace.findFileIdByName(contractPath2, contractName2)
    const iContract = workspace.editors.findIndex(ed => ed.id == contractFileId)
    
    
    if (iState < 0 || iContract < 0) {
      throw Error(`Invalid state or contract id ${iState} ${iContract}`)
    }
    contractSrc = workspace.editors[iContract].view.state.doc.toString()
    initStateSrc = workspace.editors[iState].view.state.doc.toString()

    // Validate initial state
    try {
      JSON.parse(initStateSrc)
    } catch (error) {
      throw Error(`Invalid state: ${error} file ${stateName2}`)
    }

    const wallet: ArWallet = props.login.key
    
    const contract: ContractData = {
      wallet: wallet,
      initState: initStateSrc,
      src: contractSrc,
      tags: tags
    }
    const disableBundling = txtDisableBundling.value

    // Check balance
    if (balance.value == 0 && disableBundling ||
        balance.value == 0 && warpContracts.onLocalnet(arweave)) {
      throw Error('Not enough balance! You need to have at least some AR to use this feature.')
    }

    // Use signer?
    if (!disableBundling) {
      contract.wallet = await props.login.getUserSigner()
    }

    const tx = await warpContracts.createContract(contract, disableBundling)

    if (tx) {
      deployedContractTX.value = tx
      createToast('Contract deployed!',
      {
        type: 'success',
        showIcon: true,
        position: 'bottom-right',
      })

      if (warpContracts.onLocalnet(arweave)) {
        // Call mine 
        const miningRes = await arweaveWrapper.arlocalMine()
        console.log('Confirmed tx: ', miningRes)
        createToast('Transaction confirmed!',
        {
          type: 'success',
          showIcon: true,
          position: 'bottom-right',
        })
      }

    } else {
      throw Error('Error creating tx', tx)
    }
    
    
  } catch (err) {
    let error = `${err}`
    if (typeof(err) === 'object' &&
        Object.prototype.hasOwnProperty.call(err, 'message')) {
      error = err.message
    }
    createToast(error,
    {
      type: 'danger',
      showIcon: true,
      position: 'bottom-right',
    })
    console.error('deployContract', err)
  }
  

  loadingDeployContract.value = false
};



const deployContractFromTX = async (
  statePath: string, 
  contractSrcTX: string,
  workspace: DefaultWorkspace,
  tags: Tags) => {
  let initStateSrc = ``
  loadingDeployContract.value = true
  try {
    
    const useArweaveGw = txtUseArweaveGw2.value
    const customGw = ''
    const arweaveWrapper = new ArweaveWrapper(selNetwork.value)
    const arweave = arweaveWrapper.arweave
    const warpContracts = new WarpContracts(arweave, customGw, useArweaveGw)
    // Iframe fix
    const loginMethod = props.login.method
    if (isBridgeActive.value && (loginMethod === 'arconnect' || loginMethod === 'finnie')) {
      props.login.hijackArweavePostAPI(arweave.arweave)
    }

    const stateName2 = statePath.split('/')[statePath.split('/').length - 1]
    let statePath2 = statePath.split('/').splice(0, statePath.split('/').length - 1).join('/')
    if (statePath2 === '') {
      statePath2 = '/'
    }
    const stateFileId = workspace.findFileIdByName(statePath2, stateName2)
    const iState = workspace.editors.findIndex(ed => ed.id == stateFileId)
    const wallet: ArWallet = props.login.key
    if (iState < 0 || !contractSrcTX) {
      throw Error(`Invalid state or contract id ${iState} ${contractSrcTX}`)
    }
    initStateSrc = workspace.editors[iState].view.state.doc.toString()
    
    const contract: FromSrcTxContractData = {
      wallet: wallet,
      initState: initStateSrc,
      srcTxId: contractSrcTX,
      tags: tags
    }
    
    const disableBundling = txtDisableBundling2.value

    // Check balance
    if (balance.value == 0 && disableBundling ||
        balance.value == 0 && warpContracts.onLocalnet(arweave)) {
      throw Error('Not enough balance! You need to have at least some AR to use this feature.')
    }

    // Use signer?
    if (!disableBundling) {
      contract.wallet = await props.login.getUserSigner()
    }

    const tx = await warpContracts.createContractFromTX(contract, disableBundling)
    
    if (tx) {
      deployedContractTX.value = tx
      createToast('Contract deployed!',
      {
        type: 'success',
        showIcon: true,
        position: 'bottom-right',
      })

      if (warpContracts.onLocalnet(arweave)) {
        // Call mine 
        const miningRes = await arweaveWrapper.arlocalMine()
        console.log('Confirmed tx: ', miningRes)
        createToast('Transaction confirmed!',
        {
          type: 'success',
          showIcon: true,
          position: 'bottom-right',
        })
      }

    } else {
      throw Error('Error creating tx', tx)
    }
    
    
  } catch (err) {
    let error = `${err}`
    if (typeof(err) === 'object' &&
        Object.prototype.hasOwnProperty.call(err, 'message')) {
      error = err.message
    }
    createToast(error,
    {
      type: 'danger',
      showIcon: true,
      position: 'bottom-right',
    })
  }
  

  loadingDeployContract.value = false
};

const removeTag = (index: number, tags: Tags) => {
  tags.splice(index, 1)
};

const addTag = (key: string, value: string, tags: Tags) => {
  tags.push({ key, value })
};

const testnetMintTokens = async (qty='1000000000000') => {
  try {
    const net = networks.value[selNetwork.value]
    const url = `${net.protocol}://${net.host}:${net.port}/mint/${mainAddress.value}/${qty}`
    const res = await fetch(url)
    if (res.status === 200) {
    createToast('Tokens minted!',
      {
        type: 'success',
        showIcon: true,
        position: 'bottom-right',
      })
    } else {
      console.log('Error:', res)
      createToast('Tokens not minted!',
      {
        type: 'danger',
        showIcon: true,
        position: 'bottom-right',
      })
    }

    // Update balance after 1 second 
    window.setTimeout(async () => {
      const arweaveWrapper = new ArweaveWrapper(selNetwork.value)
      balance.value = await arweaveWrapper.arweave.wallets.getBalance(mainAddress.value)
      balance.value = arweaveWrapper.winstonToAr(balance.value)
    }, 1500)


  } catch (err) {
    createToast(err,
    {
      type: 'danger',
      showIcon: true,
      position: 'bottom-right',
    });
  }
};

onMounted(async () => {
  // Get wallet balance
  if (mainAddress.value) {
    balance.value = 0
    try {
      const arweaveWrapper = new ArweaveWrapper(selNetwork.value)
      balance.value = await arweaveWrapper.arweave.wallets.getBalance(mainAddress.value)
      balance.value = arweaveWrapper.winstonToAr(balance.value)
      prevNetwork.value = selNetwork.value
    } catch (err) {
      createToast(`${err}`,
      {
        type: 'danger',
        showIcon: true,
        position: 'bottom-right',
      })
    }
  }

  // Check ifarme conditions
  isBridgeActive.value = false
  if (props.iframe) {
    // Start handshake with parent 
    try {
      isBridgeActive.value = await props.login.isBridgeActive()

    } catch (err) {
      createToast(`${err}`,
      {
        type: 'danger',
        showIcon: true,
        position: 'bottom-right',
      });
    }
  }
});

watchEffect(async () => {
  // Balance for Method 1
  if (mainAddress.value && selNetwork.value != prevNetwork.value) {
    balance.value = 0
    try {
      const arweaveWrapper = new ArweaveWrapper(selNetwork.value)
      balance.value = await arweaveWrapper.arweave.wallets.getBalance(mainAddress.value)
      balance.value = arweaveWrapper.winstonToAr(balance.value)
      prevNetwork.value = selNetwork.value;

      resetForms();
    } catch (err) {
      createToast(`${err}`,
      {
        type: 'danger',
        showIcon: true,
        position: 'bottom-right',
      });
    }
  }
});

const resetForms = () => {
  selDeployFileContractLocation.value = ''
  txtDeployFileContractLocationByTx.value = ''
  selDeployFileStateLocation.value = ''
  selDeployFileStateLocation2.value = ''
  deployedContractTX.value = ''
  loadingDeployContract.value = false
  txtUseArweaveGw.value = false
  txtDisableBundling.value = false
  txtUseArweaveGw2.value = false
  txtDisableBundling2.value = false

  if (onLocalnetByString(selNetwork.value)) {
    txtDisableBundling2.value = true
    txtDisableBundling.value = true
  }
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    (mainAddress.value && !deployedContractTX.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _withDirectives(_createElementVNode("select", {
              disabled: loadingDeployContract.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selNetwork).value = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(networks), (nItem, nIndex) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: nIndex,
                  value: nIndex
                }, _toDisplayString(nItem.host) + " (" + _toDisplayString(nIndex) + ")", 9, _hoisted_6))
              }), 128))
            ], 8, _hoisted_5), [
              [
                _vModelSelect,
                selNetwork.value,
                void 0,
                { trim: true }
              ]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("input", {
              type: "text",
              disabled: "",
              value: mainAddress.value
            }, null, 8, _hoisted_9)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _withDirectives(_createElementVNode("select", {
              onChange: _cache[1] || (_cache[1] = ($event: any) => (resetForms())),
              disabled: loadingDeployContract.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selDeployMethod).value = $event))
            }, _hoisted_15, 40, _hoisted_12), [
              [
                _vModelSelect,
                selDeployMethod.value,
                void 0,
                { trim: true }
              ]
            ])
          ]),
          (selDeployMethod.value === 'contract-src-file')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _withDirectives(_createElementVNode("select", {
                    disabled: loadingDeployContract.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selDeployFileContractLocation).value = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.workspace.getFileTreeFilenames(), (path) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: path }, [
                        (path && path.search(/.js$/) >= 0)
                          ? (_openBlock(), _createElementBlock("option", {
                              key: 0,
                              value: path
                            }, _toDisplayString(path), 9, _hoisted_19))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ], 8, _hoisted_18), [
                    [
                      _vModelSelect,
                      selDeployFileContractLocation.value,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _withDirectives(_createElementVNode("select", {
                    disabled: loadingDeployContract.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selDeployFileStateLocation).value = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.workspace.getFileTreeFilenames(), (path) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: path }, [
                        (path && path.search(/.json$/) >= 0)
                          ? (_openBlock(), _createElementBlock("option", {
                              key: 0,
                              value: path
                            }, _toDisplayString(path), 9, _hoisted_23))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ], 8, _hoisted_22), [
                    [
                      _vModelSelect,
                      selDeployFileStateLocation.value,
                      void 0,
                      { trim: true }
                    ]
                  ])
                ]),
                _hoisted_24,
                (!tagsList1.length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_25, "No tags."))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tagsList1, (tL1, index1) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "data-input-list",
                    key: index1
                  }, [
                    _createElementVNode("div", _hoisted_26, [
                      _hoisted_27,
                      _withDirectives(_createElementVNode("input", {
                        disabled: loadingDeployContract.value,
                        type: "text",
                        "onUpdate:modelValue": ($event: any) => ((tL1.name) = $event)
                      }, null, 8, _hoisted_28), [
                        [
                          _vModelText,
                          tL1.name,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _withDirectives(_createElementVNode("input", {
                        disabled: loadingDeployContract.value,
                        type: "text",
                        "onUpdate:modelValue": ($event: any) => ((tL1.value) = $event)
                      }, null, 8, _hoisted_31), [
                        [
                          _vModelText,
                          tL1.value,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_unref(DefaultIcon), {
                        onClick: ($event: any) => (removeTag(index1, tagsList1)),
                        class: "icon-action",
                        icon: "codicon-trash"
                      }, null, 8, ["onClick"])
                    ])
                  ]))
                }), 128)),
                _hoisted_33,
                _createElementVNode("ul", _hoisted_34, [
                  _createElementVNode("li", null, [
                    _createElementVNode("span", _hoisted_35, _toDisplayString(balance.value), 1),
                    _createTextVNode(" AR ")
                  ]),
                  _createElementVNode("li", _hoisted_36, [
                    (_unref(onLocalnetByString)(selNetwork.value))
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "link",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (testnetMintTokens()))
                        }, "+ Mint 1 AR"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("label", _hoisted_37, [
                      _withDirectives(_createElementVNode("input", {
                        disabled: _unref(onLocalnetByString)(selNetwork.value),
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((txtUseArweaveGw).value = $event)),
                        type: "checkbox"
                      }, null, 8, _hoisted_38), [
                        [
                          _vModelCheckbox,
                          txtUseArweaveGw.value,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      _createTextVNode(" useArweaveGw (Instead of Warp Gw) ")
                    ])
                  ]),
                  _createElementVNode("li", null, [
                    _createElementVNode("label", _hoisted_39, [
                      _withDirectives(_createElementVNode("input", {
                        disabled: _unref(onLocalnetByString)(selNetwork.value),
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((txtDisableBundling).value = $event)),
                        type: "checkbox"
                      }, null, 8, _hoisted_40), [
                        [
                          _vModelCheckbox,
                          txtDisableBundling.value,
                          void 0,
                          { trim: true }
                        ]
                      ]),
                      _createTextVNode(" disableBundling (Disable Warp Sequencer and deploy contract directly to Arweave) ")
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_41, [
                    _createElementVNode("button", {
                      class: _normalizeClass({primary: !loadingDeployContract.value}),
                      disabled: loadingDeployContract.value,
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (addTag('', '', tagsList1)))
                    }, [
                      _createVNode(_unref(DefaultIcon), {
                        class: "icon-btn",
                        icon: "codicon-tag"
                      }),
                      _hoisted_43
                    ], 10, _hoisted_42)
                  ]),
                  _createElementVNode("li", _hoisted_44, [
                    _createElementVNode("button", {
                      class: _normalizeClass({primary: (selDeployFileStateLocation.value && selDeployFileContractLocation.value) && !loadingDeployContract.value}),
                      disabled: (!selDeployFileStateLocation.value || !selDeployFileContractLocation.value) || loadingDeployContract.value,
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (deployContract(
            selDeployFileStateLocation.value,
            selDeployFileContractLocation.value,
            __props.workspace,
            tagsList1)))
                    }, [
                      _createVNode(_unref(DefaultIcon), {
                        class: "icon-btn",
                        icon: "codicon-rocket"
                      }),
                      _hoisted_46
                    ], 10, _hoisted_45)
                  ])
                ])
              ], 64))
            : (selDeployMethod.value === 'contract-src-tx')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_47, [
                    _hoisted_48,
                    _withDirectives(_createElementVNode("input", {
                      disabled: loadingDeployContract.value,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((txtDeployFileContractLocationByTx).value = $event))
                    }, null, 8, _hoisted_49), [
                      [
                        _vModelText,
                        txtDeployFileContractLocationByTx.value,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _hoisted_51,
                    _withDirectives(_createElementVNode("select", {
                      disabled: loadingDeployContract.value,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((selDeployFileStateLocation2).value = $event))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.workspace.getFileTreeFilenames(), (path) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: path }, [
                          (path && path.search(/.json$/) >= 0)
                            ? (_openBlock(), _createElementBlock("option", {
                                key: 0,
                                value: path
                              }, _toDisplayString(path), 9, _hoisted_53))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ], 8, _hoisted_52), [
                      [
                        _vModelSelect,
                        selDeployFileStateLocation2.value,
                        void 0,
                        { trim: true }
                      ]
                    ])
                  ]),
                  _hoisted_54,
                  (!tagsList2.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_55, "No tags."))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tagsList2, (tL2, index2) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "data-input-list",
                      key: index2
                    }, [
                      _createElementVNode("div", _hoisted_56, [
                        _hoisted_57,
                        _withDirectives(_createElementVNode("input", {
                          disabled: loadingDeployContract.value,
                          type: "text",
                          "onUpdate:modelValue": ($event: any) => ((tL2.name) = $event)
                        }, null, 8, _hoisted_58), [
                          [
                            _vModelText,
                            tL2.name,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        _hoisted_60,
                        _withDirectives(_createElementVNode("input", {
                          disabled: loadingDeployContract.value,
                          type: "text",
                          "onUpdate:modelValue": ($event: any) => ((tL2.value) = $event)
                        }, null, 8, _hoisted_61), [
                          [
                            _vModelText,
                            tL2.value,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        _createVNode(_unref(DefaultIcon), {
                          onClick: ($event: any) => (removeTag(index2, tagsList2)),
                          class: "icon-action",
                          icon: "codicon-trash"
                        }, null, 8, ["onClick"])
                      ])
                    ]))
                  }), 128)),
                  _hoisted_63,
                  _createElementVNode("ul", _hoisted_64, [
                    _createElementVNode("li", null, [
                      _createElementVNode("span", _hoisted_65, _toDisplayString(balance.value), 1),
                      _createTextVNode(" AR ")
                    ]),
                    _createElementVNode("li", _hoisted_66, [
                      (_unref(onLocalnetByString)(selNetwork.value))
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "link",
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (testnetMintTokens()))
                          }, "+ Mint 1 AR"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("label", _hoisted_67, [
                        _withDirectives(_createElementVNode("input", {
                          disabled: _unref(onLocalnetByString)(selNetwork.value),
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((txtUseArweaveGw2).value = $event)),
                          type: "checkbox"
                        }, null, 8, _hoisted_68), [
                          [
                            _vModelCheckbox,
                            txtUseArweaveGw2.value,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        _createTextVNode(" useArweaveGw (Instead of Warp Gw) ")
                      ])
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("label", _hoisted_69, [
                        _withDirectives(_createElementVNode("input", {
                          disabled: _unref(onLocalnetByString)(selNetwork.value),
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((txtDisableBundling2).value = $event)),
                          type: "checkbox"
                        }, null, 8, _hoisted_70), [
                          [
                            _vModelCheckbox,
                            txtDisableBundling2.value,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        _createTextVNode(" disableBundling (Disable Warp Sequencer and deploy contract directly to Arweave) ")
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_71, [
                      _createElementVNode("button", {
                        class: _normalizeClass({primary: !loadingDeployContract.value}),
                        disabled: loadingDeployContract.value,
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (addTag('', '', tagsList2)))
                      }, [
                        _createVNode(_unref(DefaultIcon), {
                          class: "icon-btn",
                          icon: "codicon-tag"
                        }),
                        _hoisted_73
                      ], 10, _hoisted_72)
                    ]),
                    _createElementVNode("li", _hoisted_74, [
                      _createElementVNode("button", {
                        class: _normalizeClass({primary: (selDeployFileStateLocation2.value && txtDeployFileContractLocationByTx.value) && !loadingDeployContract.value}),
                        disabled: (!selDeployFileStateLocation2.value || !txtDeployFileContractLocationByTx.value) || loadingDeployContract.value,
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (deployContractFromTX(selDeployFileStateLocation2.value, txtDeployFileContractLocationByTx.value, __props.workspace, tagsList2)))
                      }, [
                        _createVNode(_unref(DefaultIcon), {
                          class: "icon-btn",
                          icon: "codicon-rocket"
                        }),
                        _hoisted_76
                      ], 10, _hoisted_75)
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true)
        ]))
      : (!mainAddress.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
            _createVNode(_unref(DefaultIcon), {
              class: "icon-deploy-login",
              icon: "codicon-lock"
            }),
            _hoisted_78
          ]))
        : (deployedContractTX.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
              _createVNode(_unref(DefaultIcon), {
                class: "icon-deploy-login success",
                icon: "codicon-check"
              }),
              _hoisted_80,
              _createElementVNode("p", _hoisted_81, [
                _hoisted_82,
                _hoisted_83,
                _createElementVNode("span", null, _toDisplayString(deployedContractTX.value.contractTxId), 1)
              ]),
              _createElementVNode("p", _hoisted_84, [
                _hoisted_85,
                _hoisted_86,
                _createElementVNode("span", null, _toDisplayString(deployedContractTX.value.srcTxId), 1)
              ]),
              _createElementVNode("p", null, [
                _createElementVNode("a", {
                  class: "link",
                  href: arcodePreviewUrl(deployedContractTX.value.contractTxId),
                  target: "_blank"
                }, "Preview in ArCode", 8, _hoisted_87)
              ])
            ]))
          : _createCommentVNode("", true)
  ], 64))
}
}

})